import { BillboardBannerWithLink } from "pages/[tenant]/browse/components/BillboardBannerWithLink";
import { BillboardPageContainer } from "pages/[tenant]/browse/components/BillboardPage/styles";
import { DownContent } from "pages/[tenant]/browse/components/DownContent";
import { BillboardPageProvider } from "pages/[tenant]/browse/context/BillboardPageContext";
import { ISectionContent } from "pages/[tenant]/browse/types";

import { ComponentErrorBoundary } from "shared/components/atoms/ComponentErrorBoundary";
import { useOrganizationConfig } from "shared/hooks/useOrganizationConfig";
import { IBillboardHighlight, IBillboardSection } from "shared/types/billboard";

import Vignette from "../Vignette";

interface IBillboardPageProps {
  highlights: IBillboardHighlight[];
  sections: IBillboardSection[];
  sectionContent: ISectionContent[][];
}

const BillboardPage = ({
  highlights,
  sectionContent,
  sections,
}: IBillboardPageProps) => {
  const { selectedOrganization } = useOrganizationConfig();

  const shouldUseBillboardWithBanner =
    selectedOrganization?.billboard_type === "banner";

  return (
    <BillboardPageContainer>
      {shouldUseBillboardWithBanner ? (
        <ComponentErrorBoundary>
          <BillboardBannerWithLink />
        </ComponentErrorBoundary>
      ) : (
        <BillboardPageProvider
          SSRhighlights={highlights}
          SSRsections={sections}
        >
          <Vignette />
        </BillboardPageProvider>
      )}

      <DownContent
        sectionContent={sectionContent}
        sections={sections}
        highlights={highlights}
      />
    </BillboardPageContainer>
  );
};

export default BillboardPage;
